module.exports = __webpack_public_path__ + "static/media/starPartialOff_118.5bdc3bca.png";